export const generalAppInfo = {
  APP_NAME: "The Compass application",
  APP_VERSION: "v1",
  API_VERSION: "v1",
};

export const configs = {
  KEY: "89f50f60-6cfb-4ed2-b31a-5904ea4a6c06",
  COOKIE_EXPIRY_PERIOD: 1,
  USER_ACTIVATED_STATUS: "f729960a-df75-405a-a5b6-ddf9a199a56d",
  USER_MATRIC_NUMBER: "bb96749b-b06f-4ab8-9fd0-58c8f56856ef",
};

export const Loading = {
  FETCHING: "FETCHING",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
  FAILED: "FAILED",
  LOADING: "LOADING",
};

// export const userTypes = {
//   ROLE_SYSTEM_ADMIN: "SYSTEM_ADMIN",
//   ROLE_SUPER_ADMIN: "SUPER_ADMIN",
//   ROLE_USER: "USER",
// };

export const userTypes = {
  ROLE_SYSTEM_ADMIN: "ROLE_SYSTEM_ADMIN",
  ROLE_SUPER_ADMIN: "ROLE_SUPER_ADMIN",
  ROLE_USER: "ROLE_USER",
};

export const menuType = {
  HOME: "home",
};
